/**
 * @file location-page
 * @author
 */

import React, {useCallback} from 'react';
import {recordProxy} from '../../../util';
import CompQrcode from './CompQrcode';

import noResultIcon from '../imgs/no-data.svg';
import navIcon from '../imgs/nav-icon.svg';

import {ICompAreaItem as IProps} from '../locationResInterface';

export default function CompAreaItem(props: IProps) {
    const {organData, srcid, pageType, search, pageTitle, pageTag, isNoRegionType} = props;

    const navMap = useCallback((data) => {
        const pointParam = {
            pageType,
            srcid,
            showtitle: data.showtitle,
            search,
            pageTag,
            pageTitle
        };
        recordProxy('locationNavBtn', 'click', JSON.stringify(pointParam));
        // const url = 'https://api.map.baidu.com/geocoder?location='
        //     + location.lat + ',' + location.lon
        //     + '&coord_type=gcj02&output=html&src=haoma.baidu.com';
        const url = 'http://api.map.baidu.com/geocoder?address='
            + data.address + data.showtitle + '&output=html&src=haoma.baidu.com';
        // http://api.map.baidu.com/geocoder?address=北京市海淀区上地信息路9号奎科科技大厦&output=html&src=haoma.baidu.com
        window.open(url);
    }, []);
    const showPhoneText = (value) => {
        if (value && value.length > 0) {
            let str = '';
            value.map((v, k) => {
                if (k === 0) {
                    str += v.phone;
                    if (v.link === '01012345' || v.link === '01012320') {
                        // 针对北京市疫情防控电话，需要单独处理
                        str += '【' + v.name + '】';
                    }
                } else {
                    str += '、' + v.phone;
                    if (v.link === '01012345' || v.link === '01012320') {
                        str += '【' + v.name + '】';
                    }
                }
            });
            return '电话: ' + str;
        }
    };
    return (<div>
        {organData && organData.length > 0 && organData.map((val, key) => {
            return (<div key={key} className="comp-area-item">
                <div className="organ-wrap">
                    <div className="organ-msg">
                        <div className="organ-name">
                            <div className="organ-name-text">{val.showtitle}</div>
                            {val.tag && <span className="organ-tag hospital">{val.tag}</span>}
                        </div>
                        <div className="organ-time">{showPhoneText(val.phoneList)}</div>
                        {val.address && <div className="organ-address">
                            <span>
                                地址：{val.address}
                            </span>
                            <span>
                                <img onClick={() => navMap(val)} className="nav-icon" src={navIcon} />
                            </span>
                        </div>}
                        {val.worktime && <div className="organ-time">
                            服务时间：{val.worktime}
                        </div>}
                    </div>
                    {val.phoneList && val.phoneList.length > 0
                        && <CompQrcode
                            search={val.title}
                            pageType={pageType}
                            srcid={srcid}
                            pageTitle={pageTitle}
                            pageTag={pageTag}
                        />
                    }
                </div>
                {val.disMap
                    && val.address
                    && isNoRegionType !== '1'
                    && <div className="organ-distance">距你{val.disMap}</div>}
            </div>);
        })}
        {!organData || organData.length === 0 && <div className="no-result">
            <img className="no-result-icon" src={noResultIcon} />
            <div>该地区暂未提供相关数据，请选择其他区域查看</div>
        </div>}
    </div>);
}